import { nhost } from '@/lib/nhost'
import { authedFetch } from '@/lib/auth-fetch'

/**
 * Update the current user's auth.users.metadata via the validated server route.
 *
 * metadata feeds the JWT tenant/property claims, so the browser role may no longer
 * write it directly (cross-tenant escalation — see /api/profile/metadata). The route
 * validates `tenant-id` / `active_property_id` against the caller's memberships and
 * merges with the admin secret. Contract preserved: persist → refreshSession(0) so
 * the new claims land in the in-memory token + cookie session → return merged metadata.
 */
export async function updateUserMetadata(partial: Record<string, unknown>) {
  const res = await authedFetch('/api/profile/metadata', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ metadata: partial }),
  })
  const data = (await res.json().catch(() => ({}))) as { metadata?: Record<string, unknown>; error?: string }
  if (!res.ok) {
    throw new Error(data.error || 'Failed to update user metadata')
  }

  // Ensure JWT/session picks up new metadata for RLS
  await nhost.refreshSession(0)

  return data.metadata ?? {}
}
